import React from "react";

import "./styles.scss";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);
const LineCharts = (props) => {

    const LineConfig = (scrollX) => {
        return {
            responsive: true,
            animation: {
                duration: 0
            },
            interaction: {
                mode: 'index',
                intersect: false,
            },
            stacked: false,
            scales: {
                x: {
                    display: true,
                    title: {
                        display: true,
                        text: '',
                        color: 'green'
                    }
                },
                y: {
                    type: 'linear',
                    display: true,
                    position: scrollX === 0 ? 'right' : 'left',
                    min: 0,
                    title: {
                        display: true,
                        text: '%',
                        color: 'green',
                        padding: { top: 0, left: 0, right: 0, bottom: 0 }
                    }
                }
            },
            plugins: {
                tooltip: {
                    usePointStyle: true,
                    callbacks: {
                        labelPointStyle: function (context) {
                            return {
                                pointStyle: 'triangle',
                                rotation: 0
                            };
                        },
                        label: function (value) {
                            if (value.dataset && value.dataIndex && value.dataset?.dataRl) {
                                return (value.dataset.label + ': ') + value.dataset.dataRl[value.dataIndex]
                            }
                        }
                    }
                },
                legend:{
                    display	:true,
                    position: scrollX === 0 ? 'right' : 'left',
                    fullSize: true,
                    labels:{
                        font: {
                            size: 10  
                        },
                        // color: 'rgb(255, 99, 132)',
                        padding:15, 
                        boxWidth:30,
                        boxHeight:1,
                        usePointStyle:true
                    }
                },
            },
           
        };
    };

    return (
        <div className="lineChart" >
            <Line
                ref={props.chartRef}
                data={props.dataCharts}
                options={LineConfig(props.scrollX)}
                height={110}
                // redraw
            />
        </div>
    );
}

export default LineCharts

